import React from "react";

const Header = () => {
  return (
    <header>
      <h2 className="text-white text-2xl md:text-3xl font-serif font-bold pt-2">
        Examples with Steps UI
      </h2>
      <p className="text-white text-sm md:text-base pt-1.5 opacity-80 tracking-wide">
        Follow the simple 4 steps to complete your mapping.
      </p>
    </header>
  );
};

export default Header;
